require("./sass/program_profile.sass");
require("./sass/dashboard.sass");
require("./sass/components/collaborators.sass");
require("./sass/components/navigation.sass");
require("./sass/program_list.sass");
require("./sass/application_preview.sass");
require("./sass/application_detail.sass");
require("./sass/surveys/survey.sass");
require("../sma.admin/sass/components/grid.sass");
require("../sma.admin/sass/settings/files.sass");
require("../sma.admin/sass/account.sass");
require("./sass/file_upload.sass");

require('./surveys/index');

module.exports = {
	components: {
		Modal: require('sma.common/components/modals'),
		CookieBanner: require("sma.common/components/cookie_banner"),
		Rely: require('sma.admin/components/rely'),
		DatePicker: require('sma.admin/components/datepicker'),
		TimePicker: require('sma.admin/components/timepicker'),
		FilePreviewer: require('sma.common/components/file_previewer'),
		FileUploader: require('sma.common/components/image_uploader').FileUploader,
	},
	applicants: {
		Dashboard: require('sma.applicant/dashboard/view').Dashboard,
		ApplicationDetailView: require('sma.applicant/application/view').ApplicationDetailView,
		TaskView: require('sma.applicant/tasks/view').TaskView,
		detail: {
			ApplicationPreview: require('sma.common/preview').ApplicationPreviewBase,
			CollaboratorAvatars: require('sma.applicant/detail/collaborator_avatars').CollaboratorAvatars,
			CollaboratorModal: require('sma.applicant/detail/collaborator_modal').CollaboratorModal,
		},
		components: {
			Collaborators: require('sma.applicant/components/collaborators').Collaborators,
			ReadMore: require('sma.applicant/components/readmore').ReadMore,
			InlineEdit: require('sma.applicant/components/inline_edit').InlineEdit,
			Circle: require('sma.applicant/components/circle').Circle,
			ajax: require('sma.common/ajax'),
			DownloadModal: require('sma.common/downloads').DownloadModal,
			MobileMenu: require('sma.applicant/components/mobile_menu').MobileMenu,
			MultiSelectSearch: require('sma.common/components/multi_select_search').MultiSelectSearch,
		},
	},
	downloads: {
		DownloadModal: require('sma.common/downloads').DownloadModal,
		DownloadPoll: require('sma.common/downloads').DownloadPoll,
	},

	tasks: {
		CollaboratorModal: require('sma.applicant/tasks/collaborator_modal').CollaboratorModal,
		CollaboratorGrid: require('sma.applicant/tasks/collaborator_grid').CollaboratorGrid,
		UploadTask: require('sma.applicant/tasks/upload.js').UploadTask,
		UploadTaskReadOnly: require('sma.applicant/tasks/upload.js').UploadTaskReadOnly
	},

	Account: require('sma.accounts/account').Account,
	CancelDeleteAccount: require('sma.accounts/account').CancelDeleteAccount,
	NotificationPreferences: require('sma.accounts/account').NotificationPreferences,

	programs: {
		ProgramListView: require('sma.applicant/programs/list').ProgramListView,
		ProgramDetailView: require('sma.applicant/programs/detail').ProgramDetailView,
	},

	organizations: {
		OrganizationMembersGrid: require('sma.applicant/organizations/members').OrganizationMembersGrid,
		OrganizationTeamsGrid: require('sma.applicant/organizations/teams.js').OrganizationTeamsGrid,
		OrganizationProfileView: require('sma.applicant/organizations/profile').OrganizationProfileView,
		GuideStarView: require('sma.applicant/organizations/guidestar').GuideStarView,
	},

	EmailVerification: require('sma.common/email_verification.js'),
};



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.applicant/index.js